import { render } from "./RelationsListDropdown.vue?vue&type=template&id=406d0dab&scoped=true"
import script from "./RelationsListDropdown.vue?vue&type=script&lang=js"
export * from "./RelationsListDropdown.vue?vue&type=script&lang=js"

import "./RelationsListDropdown.vue?vue&type=style&index=0&id=406d0dab&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-406d0dab"]])

export default __exports__